import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Client } from '@state/clients/client.model';
import moment from 'moment';
import {SessionQuery} from '@state/session/session.query';

@Component({
    selector: 'app-client-info',
    templateUrl: './client-info.component.html',
    styleUrls: ['./client-info.component.scss'],
    standalone: false
})
export class ClientInfoComponent {
    @Input() client: Partial<Client>;
    @Output() deleteProfilePicture = new EventEmitter<string>();

    public showContactData = this.sessionQuery.getValue().clientContactDataView;

    constructor(
        private sessionQuery: SessionQuery
    ) {}

    get clientAge(): number {
        if (!this.client?.birthDate) {
            return null;
        }

        return moment().diff(this.client.birthDate, 'y');
    }

    get icon(): string {
        if (!this.client) {
            return 'person-circle-outline';
        }

        if (!this.client.profileImage || this.client.profileImage === '') {
            if (this.client.sex) {
                return this.client.sex === 'F' ? 'woman-outline' : 'man-outline';
            } else {
                return 'person-circle-outline';
            }
        }
    }

    handleDeleteProfilePicture(id: string): void {
        this.deleteProfilePicture.emit(id);
    }
}
